export const sleep = (ms = 1000) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export const isNull = (val) => {
  return val === null || val === undefined
}

export const notNull = (val) => {
  return val !== null && val !== undefined
}

export const isValue = (val) => {
  return val !== null && val !== undefined && val !== ''
}

export const isTextError = (val, text) => {
  return val === '' || val === null ? text : undefined
}

const randomInt = (min = 0, max = 231) => {
  const crypto = window.crypto || window.msCrypto
  const byteArray = new Uint8Array(1)
  crypto.getRandomValues(byteArray)
  let randomNum = `0.${byteArray[0].toString()}`

  return Math.floor(randomNum * (max - min + 1)) + min
}

export const random = ({
  len,
  prefix = '',
  postfix = '',
  character = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
}) => {
  let need = len - (prefix.length + postfix.length)
  let max = character.length
  if (need < 0) return
  if (max === 0) return
  let resp = ''

  for (let i = 0; i < need; i++) {
    resp += character.charAt(randomInt(0, max - 1))
  }

  return `${prefix}${resp}${postfix}`
}

export const isUrl = (val) => {
  if (isValue(val)) {
    let prefix = val.substring(0, 4)
    return prefix === 'http'
  }

  return false
}

export const trim = (data, list = []) => {
  list.forEach((name) => {
    let temp = data[name]
    if (temp) data[name] = temp.trim()
  })

  return data
}

export const compareString = (src, target) => {
  return String(src).toLocaleLowerCase() === String(target).toLocaleLowerCase()
}

export const getUrl = (list = []) => {
  const img_url = list.length > 0 ? list[0] : undefined
  return img_url
}

export const isValidEmail = (email) => {
  if (!email) return false
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
